import { InjectionToken } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export interface IFirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  locationId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

export const FIREBASE_CONFIG = new InjectionToken<IFirebaseConfig>('FIREBASE_CONFIG', {
  providedIn: 'any',
  factory: () => {
    throw new Error('Provide FIREBASE_CONFIG');
  },
});
export const USE_EMULATORS = new InjectionToken<boolean>('USE_EMULATORS', {
  providedIn: 'any',
  factory: () => {
    throw new Error('Provide USE_EMULATORS');
  },
});

export function preloadUser(transloco: TranslocoService) {
  return function () {
    const lang = 'hu';
    transloco.setActiveLang(lang);
    return transloco.load(lang).toPromise();
  };
}
export const FirebaseConfigToken = new InjectionToken<IFirebaseConfig>('FirebaseConfigToken');
export const AngularProjectContext = new InjectionToken<{
  service?: string;
  version?: string;
}>('AngularProjectContext');
